import React from "react";
import "./Facility.css";
import Footer from "../Footer/Footer";
import facilityBanner from "../../assets/facilities/varanousoffice.jpeg";
import researchlabs from '../../assets/researchlabs.jpg';
import advanceresearchlabs from "../../assets/advanceresearchlabs.jpg";
import research from "../../assets/facilities/researchpic1.jpeg";
import Researchdepartments from "../../assets/facilities/Researchdepartments.jpg";
import qualityControl from "../../assets/facilities/qualitycontol_varanous.webp";
import qualitytest from "../../assets/facilities/qualitytest.jpg";
import productionArea from "../../assets/facilities/productionarea.jpg";
import warehouse from "../../assets/facilities/varanous_warehouse.webp";
import conferenceRoom from "../../assets/facilities/conferenceroom.jpg";

const Facility = () => {
  return (
    <div className="facility-container">
      <div className="facility-banner">
        <img src={facilityBanner} alt="Facility Banner" />
        <div className="facility-banner-text">Facility</div>
      </div>

      <div className="facility-header">
        <h1>Our Facility</h1>
        <p>
          We are a chemistry-driven contract research organization catering to both domestic and international customers. We are specialized in the synthesis of Advanced drug intermediates across a wide spectrum of chemistry types.
        </p>
      </div>

      <div className="facility-grid">
        <div className="facility-card">
          <img src={researchlabs} alt="Research Lab" />
          <h3>Research Labs</h3>
        </div>

        <div className="facility-card">
          <img src={advanceresearchlabs} alt="Advanced Research Lab" />
          <h3>Advanced Research Lab</h3>
        </div>

        <div className="facility-card">
          <img src={research} alt="Research" />
          <h3>Research</h3>
        </div>

        <div className="facility-card">
          <img src={Researchdepartments} alt="Research Department" />
          <h3>Research Department</h3>
        </div>

        <div className="facility-card">
          <img src={qualityControl} alt="Quality Control" />
          <h3>Quality Control</h3>
        </div>

        <div className="facility-card">
          <img src={qualitytest} alt="Quality Test" />
          <h3>Quality Test</h3>
        </div>

        <div className="facility-card">
          <img src={productionArea} alt="Production Area" />
          <h3>Production Area</h3>
        </div>

        <div className="facility-card">
          <img src={warehouse} alt="warehouse" />
          <h3>warehouse</h3>
        </div>

        <div className="facility-card">
          <img src={conferenceRoom} alt="Conference Room" />
          <h3>Conference Room</h3>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Facility;